import { render, staticRenderFns } from "./EditSeriesModal.vue?vue&type=template&id=06e4b6bf"
import script from "./EditSeriesModal.vue?vue&type=script&lang=js"
export * from "./EditSeriesModal.vue?vue&type=script&lang=js"
import style0 from "./EditSeriesModal.vue?vue&type=style&index=0&id=06e4b6bf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports